<template>
  <div>
    <Alert show-icon>你正在申请「<b style="color: red">{{ tenantInfo.name }}</b>」项目的工作流，可从右上角切换项目</Alert>
  </div>
</template>

<script>
import { detailTenants } from '@/api/user'
export default {
  name: 'general-alert',
  data () {
    return {
      tenantInfo: {}
    }
  },
  created: function () {
    this.getInfo()
  },
  watch: {
    '$store.state.user.defaultTenant' () {
      this.getInfo()
    }
  },
  methods: {
    getInfo () {
      if (this.$store.state.user.defaultTenant) {
        detailTenants(this.$store.state.user.defaultTenant).then(res => {
          this.tenantInfo = res.data
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
